import { track } from './client';
import { getTelemetryPage } from './context';
import { safely } from './safely';

export interface FilterField {
  field: string;
  kind: string;
  /** The value as it is written to the URL: `A|B` for a list, `''` when cleared. */
  value: string;
}

// Dropdown selections (kind 'list') are the only values sent: typed text is a customer's name,
// email or phone. The page number is navigation, not a filter.
export function reportFilterChanges(
  previous: Record<string, string>,
  fields: FilterField[],
): void {
  safely(() => {
    const page = getTelemetryPage();
    fields.forEach(({ field, kind, value }) => {
      if (kind === 'page' || (previous[field] ?? '') === value) return;
      track('filter_changed', {
        page,
        field,
        value: kind === 'list' && value ? value : undefined,
        cleared: !value,
      });
    });
  });
}
